import {
  SET_TARGET_YM,
  SET_TARGET_FUNC,
  SET_ACCESS_LOG,
  SET_DISP_ACCESS_LOG,
  SET_INIT_LOG_OUTPUT_STATE,
  SET_TARGET_DATE_LIST,
  SET_ROLE_LIST,
} from '../actions/LogOutputAction';

const initState = {
  // 選択された年月
  targetYM: null,
  // 選択されたアクション
  targetFunc: null,
  // アクセスログ
  accessLog: {},
  // アクセスログ表示リスト
  dispAccessLog: {},
  // 対象年月リスト
  targetList: null,
  // 権限リスト
  roleList: null,
};

export default (state = initState, action) => {
  switch (action.type) {
    case SET_TARGET_YM:
      return { ...state, targetYM: action.targetYM };
    case SET_TARGET_FUNC:
      return { ...state, targetFunc: action.targetFunc };
    case SET_ACCESS_LOG:
      return { ...state, accessLog: action.accessLog };
    case SET_DISP_ACCESS_LOG:
      return { ...state, dispAccessLog: action.dispAccessLog };
    case SET_INIT_LOG_OUTPUT_STATE:
      return { ...initState };
    case SET_TARGET_DATE_LIST:
      return { ...state, targetList: action.targetList };
    case SET_ROLE_LIST:
      return { ...state, roleList: action.roleList };
    default:
      return state;
  }
};
